export enum CognitoMonitoringEvents {
  loggedUserWithoutAccountId = 'loggedUserWithoutAccountId',
}
